import {isEditor, isMobile} from '../../../../../commons/selectors/environment'
import {getListLayout, isEmptyStateNotificationVisible, isNarrow} from '../../selectors/list-settings'
import {getComponentConfig, isSingleEventWidget} from '../../selectors/settings'
import {isButtonLayout} from '../../selectors/single-settings'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {LayoutOwnProps, LayoutStateProps} from './interfaces'
import {Layout as Presentation} from './layout'

const mapRuntime = ({state, host}: AppProps): LayoutStateProps => ({
  listLayout: getListLayout(getComponentConfig(state)),
  singleEventWidget: isSingleEventWidget(getComponentConfig(state)),
  emptyStateVisible: isEmptyStateNotificationVisible(state),
  mobile: isMobile(state),
  buttonOnly: isButtonLayout(state.component),
  editor: isEditor(state),
  narrowLayout: isNarrow(state, host.dimensions),
})

export const Layout = connect<LayoutOwnProps, LayoutStateProps>(mapRuntime)(Presentation)
